module.exports = __webpack_public_path__ + "static/media/external-link-icon-3.58f4c051.svg";